import {Box, alpha, styled} from '@mui/material';
import {VariantType} from './constants';
import {GetIconBgColorsProps} from './types';

const getIconColor = ({variant, theme}: GetIconBgColorsProps) => {
	const colorMapping: Record<VariantType, string> = {
		default: theme.palette.grey[500],
		error: theme.palette.error.dark,
		success: theme.palette.success.dark,
		info: theme.palette.customInfo.dark,
		warning: theme.palette.customWarning.dark,
		primary: theme.palette.primary.main,
		secondary: theme.palette.secondary.dark,
	};

	return colorMapping[variant];
};

export const IconContainer = styled(Box)<GetIconBgColorsProps>`
	background-color: ${({variant, theme}) => alpha(getIconColor({theme, variant}), 0.12)};
	color: ${({variant, theme}) => getIconColor({variant, theme})};
	border-radius: 50%;
	padding: ${({$customSize}) =>
		$customSize === 'smaller' || $customSize === 'custom' ? 8 : 16}px;
	display: flex;
`;
